import api from './api';

const memoryCache = {};
const pendingPromises = {};

/**
 * Fetches QuestionsLookups with automatic in-memory deduplication and caching.
 * Prevents redundant HTTP calls when multiple question components mount simultaneously.
 * 
 * @param {string} endpoint - The API lookup endpoint (e.g., '/QuestionsLookups/SkillsCategories')
 * @returns {Promise<any>}
 */
export function getCachedLookup(endpoint) {
    if (!endpoint) return Promise.resolve({ data: [] });

    // 1. Return cached response immediately if available (0ms)
    if (memoryCache[endpoint]) {
        return Promise.resolve(memoryCache[endpoint]);
    }

    // 2. Return active pending HTTP request if in-flight (Deduplication)
    if (pendingPromises[endpoint]) {
        return pendingPromises[endpoint];
    }

    // 3. Initiate single HTTP request
    pendingPromises[endpoint] = api.get(endpoint)
        .then(res => {
            memoryCache[endpoint] = res;
            delete pendingPromises[endpoint];
            return res;
        })
        .catch(err => {
            delete pendingPromises[endpoint];
            throw err;
        });

    return pendingPromises[endpoint];
}

/**
 * Clears the lookup cache (useful when categories or skills are edited/re-saved).
 */
export function clearLookupCache(endpoint) {
    if (endpoint) {
        delete memoryCache[endpoint];
        delete pendingPromises[endpoint];
    } else {
        Object.keys(memoryCache).forEach(k => delete memoryCache[k]);
        Object.keys(pendingPromises).forEach(k => delete pendingPromises[k]);
    }
}
